var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 22,
    viewBox: "0 0 31 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.225 2.675C28.4112 1.2275 27.5281 0.96125 25.73 0.86C23.9338 0.738125 19.4169 0.6875 15.5037 0.6875C11.5831 0.6875 7.06437 0.738125 5.27 0.858125C3.47562 0.96125 2.59063 1.22562 1.76937 2.675C0.93125 4.12063 0.5 6.61062 0.5 10.9944V11.0094C0.5 15.3744 0.93125 17.8831 1.76937 19.3137C2.59063 20.7612 3.47375 21.0238 5.26813 21.1456C7.06437 21.2506 11.5831 21.3125 15.5037 21.3125C19.4169 21.3125 23.9338 21.2506 25.7319 21.1475C27.53 21.0256 28.4131 20.7631 29.2269 19.3156C30.0725 17.885 30.5 15.3762 30.5 11.0112V10.9963C30.5 6.61063 30.0725 4.12063 29.225 2.675Z",
    fill: "#F44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.75 16.625V5.375L21.125 11L11.75 16.625Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.99d211c9475f0c08a26939f438f0547c.svg";
export { ForwardRef as ReactComponent };